import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=deb72970&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "../assets/css/index.scss?vue&type=style&index=0&id=deb72970&prod&lang=scss&scoped=true&external"
import style1 from "./indexNew.vue?vue&type=style&index=1&id=deb72970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb72970",
  null
  
)

export default component.exports